import React from 'react';

import { Container } from './styles';

const News: React.FC = () => {
  return (
    <Container>
      <span>Assuntos do momento no Brasil</span>
      <strong>Assuntos do momento no Brasil</strong>
    </Container>
  );
};

export default News;
